import React from "react";
import { Box } from "@mui/material";
import { useAccountInfo } from "../../hooks/useAccountInfo";
import { responseToError } from "firebase-tools/lib/responseToError";
import { useFreshdeskSso } from "../../hooks/useFreshdeskSso";

function SsoPage() {
  useFreshdeskSso();

  return <Box className={"max-w-full"}></Box>;
}

export default SsoPage;
